// extracted by mini-css-extract-plugin
export var externalLink = "_bz-0";
export var internalLinkLabel = "_bz-1";